<template>
	<div id="app">
		<headertop ></headertop>
		<div class="main">
			<!-- 面包屑-->
			<div style="padding: 20px;">
				<!-- 视频-->
				<el-form class="videoplay left" ref="video">
					<el-form-item prop="video" style="width: 100%">
						<div class="whole">
							<div class="player-div">
								<video ref="videoPlayer" class="video-js video vjs-big-play-centered"
									controlslist="nodownload noremoteplayback" oncontextmenu="return false">
								</video>
							</div>
							<el-button size="mini" class="btn-s" ref="btns" @click="hide"><i
									class="el-icon-arrow-left"></i>
							</el-button>
						</div>
					</el-form-item>
				</el-form>

				<!-- 侧边栏 -->
				<div class="videocard right">
					<el-button size="mini" class="btn-h" ref="btnh" @click="hide"><i class="el-icon-arrow-right"></i>
					</el-button>
					<!-- 简介 -->
					<el-tabs class="box-card " v-model="activeName" type="card" @tab-click="handleClick" ref="card">
						<el-tab-pane label="简介" name="first">
							<div class="tabs_overflow">
								<p style="margin-left:1.5rem;">课程简介</p>
								<div v-html="tabs.introduce_list.content" class="fontsize"
									style="margin-top:20px;margin:1rem 1.5rem 0 1.5rem"></div>
								<p style="margin-left:1.5rem;" >课程详情</p>
								<div v-html="tabs.introduce_list.info"
                class="fontsize"
									style="margin-top:20px;margin:1rem 1.5rem 0 1.5rem"></div>
								<p style="margin-left:1.5rem;" >讲师介绍</p>
								<!-- <div  style="margin-top:20px;margin:1rem 1.5rem 0 1.5rem">{{tabs.introduce_list.teacher}}</div>
              <div  style="margin-top:20px;margin:1rem 1.5rem 0 1.5rem">{{tabs.introduce_list.teacher_img}}</div> -->
								<div v-html="tabs.introduce_list.teacher_content"
                class="fontsize"
									style="margin-top:20px;margin:1rem 1.5rem 0 1.5rem"></div>
								<div v-html="tabs.introduce_list.teacher_info"
                class="fontsize"
									style="margin-top:20px;margin:1rem 1.5rem 0 1.5rem"></div>
							</div>
						</el-tab-pane>
						<!-- 互动-->
						<el-tab-pane label="互动" name="second" class="tabs_overflow" id="tabs">
							<div v-for="(item,key) in tabs.interaction_list " style=" margin-top: 1rem;">
								<div v-if="item.userNum !=info.serial_number">
									<div class="left">
										<el-avatar :size="40" :src="item.img"></el-avatar>
									</div>
									<div style="chat_content" class="fontsize">
										<div style="top: 0; margin-left: 1rem; "> <span class="fontsize">
												{{item.user}}&nbsp;&nbsp;{{item.time.slice(10)}}</span></div>
										<div class="chat_div" style="background-color: #A9A9A9;"> <img v-if="item.checked==1"
												style="width: 3rem; height: 3rem;"
												src="../../../assets/Livebroadcasting_ask.png" /> {{item.msg}}</div>
									</div>
								</div>
								<div class="fontsize" style="margin-top: 1rem;  overflow:hidden" v-else>
									<div class="right">
										<el-avatar :size="40" :src="item.img"></el-avatar>
									</div>
									<div style="width: 90%;" class="fontsize">
										<div style="top: 0; width: 100%; "> <span class="right">
												{{item.user}}&nbsp;&nbsp;{{item.time.slice(10)}}</span></div><br>
										<div style="width: 100%;">
											<div class="chat_div_right right" style="background-color: #A9A9A9;"><img v-if="item.checked==1"
													style="width: 3rem; height: 3rem;"
													src="../../../assets/Livebroadcasting_ask.png" /> {{item.msg}}</div>
											<br>
										</div>
									</div>
								</div>
							</div>
						</el-tab-pane>
						<!-- 评价-->
						<el-tab-pane label="评价" name="third" class="tabs_overflow" style="height: calc(100% - 105px);">
							<div style="	width: 100%;position: absolute;top: 0;background-color: #FFFFFF;">
								<i style="float: right;" class="el-icon-refresh-right" @click="refresh()"></i>
								<el-rate v-model="rate.average" disabled show-score text-color="#ff9900">
								</el-rate>
							</div>
							<div style="margin-top: 1rem;   width: 100%; height: 0.1rem;background-color: white;"></div>
							<div  id="tabs_evaluate" >
								<div v-for="item in rate.list" style="margin-top: 1rem;">
									<div class="left">
										<el-avatar :size="40" :src="item.img"></el-avatar>
									</div>
									<div>
										<div  style="top: 0; margin-left: 1rem;">
											<el-rate  v-model="item.rate_num" disabled show-score text-color="#ff9900">
											</el-rate>
										</div>
										<div class="chat_div fontsize"> {{item.content}}</div>
									</div>
								</div>
							</div>
							<div class="evaluate_end " >
								<el-rate style="margin-top: 0.6rem; margin-left: 0.2rem;" v-model="rate.updata.rate_num"
									show-text>
								</el-rate>
								<el-input style="margin-left: 0.2rem; margin-top: 0.7rem; width: 70%;" type="textarea"
									:rows="3" v-model="rate.updata.content" placeholder="请输入内容"></el-input>
								<div class="last_button">
									<button @click="release" class="relesse_div">发布</button>
								</div>
							</div>
						</el-tab-pane>

					</el-tabs>
				</div>
        <div style="width: 75%; " v-if="tabs.introduce_list.chat=='1'">
        		<el-input placeholder="请输入内容" v-model="input" class="input-with-select" @change="send">
        			<template slot="prepend">
        				<el-checkbox v-model="tabs.checked">提问</el-checkbox>
        			</template>
        		</el-input>
        	</div>
        </div>
			</div>

			<el-dialog title="请输入秘钥" :visible.sync="autograph.show" :close-on-click-modal="false" :show-close="false"
				@close="closeDialog()">
				请输入秘钥: <el-input show-password v-model="autograph.input" style="margin: 1rem 0 1rem 0 ;"></el-input>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="autograph_click('ok')">确 认</el-button>
					<el-button @click="autograph_click('on')">取消</el-button>
				</div>
			</el-dialog>
      <footerbom></footerbom>
		</div>


	</div>
</template>

<script>
	import Header from '../../../components/index/public/NavHeader.vue';
	import Footer from '../../../components/index/public/NavFooter.vue';
	export default {
		name: 'App',
		data() {
			return {
				activeName: 'first',
				study_time_status: null,
				autograph: {
					show: false,
					input: ''
				},
				play: {
					type: this.$route.query.type,
					num: this.$route.query.num,
					resource: this.$route.query.resource,
					info: {},
					list: [],
					note: [],
					status: false,
					old_time: 0
					// name:''
				},
				player: null,
				videoOptions: {
					// lang: 'zh-CN',
					autoplay: false, //自动播放
					controls: true, //用户可以与之交互的控件
					// loop:false,//视频一结束就重新开始
					muted: false, //默认情况下将使所有音频静音
					// aspectRatio:"16:9",//显示比率
					// preload:false,//预加载
					notSupportedMessage: '此视频暂无法播放，请稍后再试',
					errorDisplay: false,
					fluid: true,
					fullscreen: {
						options: {
							navigationUI: 'hide'
						}
					},
					sources: [{
						src: "",
						type: ""
					}],
				},
				video_hight: '',
				info: this.$store.state.info,
				num: this.$route.query.num,
				rate: { //星星
					updata: {
						rate_num: null,
						content: '', //输入框
					},
					list: [], //互动列表
					average: 0, //平均
				},

				socket: {
					wsServer: "wss://edu.zhiyaozhishi.com/websocket",
					websocket: null,
				},

				tabs: {
					switch: 'introduce',
					watch_num: 0,
					introduce_list: {}, //简介详情列表i
					checked: false, //提问或聊天
					interaction_list: [], //互动列表
					question_list: [],
					chatbox_show: false, //显示聊天的div
				},
				input: '', //输入框
			}
		},
		components: {
			headertop: Header,
			footerbom: Footer,
		},
		mounted: function() {
			this.change_height()
			this.check_live_power()
		},

		methods: {
			refresh() {
				this.get_comment();
			},
			check_live_power() {
				let _this = this
				_this.axios.get("/v2/user_live/check_live_power", {
					params: {
						'num': _this.num
					},
				}).then(function(res) {
					if (res.status == "200") {
						if (res.data.code == "1") {
							_this.check_live_pwd_status()
						} else {
							_this.$message.error(res.data.msg)
						}
					} else {
						_this.$message.error("服务器内部错误")
					}
				});
			},
			check_live_pwd_status() {
				let _this = this
				_this.axios.get("/v2/user_live/check_live_pwd_status", {
					params: {
						'num': _this.num
					},
				}).then(function(res) {
					if (res.status == "200") {
						if (res.data.code == "1") {
							if (res.data.data) {
								_this.autograph.show = true
							} else {
								_this.get_info()
							}
						} else {
							_this.$message.error(res.data.msg)
						}
					} else {
						_this.$message.error("服务器内部错误")
					}
				});
			},
      autograph_click(type) {
      	let _this = this
      	if (type == 'ok') {
      		if (_this.autograph.input.length == 0) {
      			_this.$message.error('请输入秘钥')
      			return false
      		}
      		_this.axios.post('/v2/user_live/check_live_pwd', {
      			data: {
      				'num': _this.num,
      				'pwd': _this.autograph.input
      			}
      		}).then(function(res) {
      			if (res.status == '200') {
      				if (res.data.code == '1') {
      					_this.autograph.show = false
      				} else {
      					_this.$message.error(res.data.msg)
      				}
      			} else {
      				_this.$message.error('服务器内部错误')
      			}
      		}).catch(function(error) {
      			_this.$message.error('服务器内部错误')
      		})
      	} else {
      		_this.$router.push({
      			path: '/Liveintroduce',
      			query: {
      				num: _this.num
      			}
      		})
      	}
      },
      closeDialog(){
        this.get_info()
      },
			get_info() {
				let _this = this
				_this.axios.get("/v2/user_live/get_live", {
					params: {
						'num': _this.num
					},
				}).then(function(res) {
					if (res.status == "200") {
						if (res.data.code == "1") {
							_this.tabs.introduce_list = res.data.data
							_this.videoOptions.sources[0].src = res.data.data.watch
							_this.videoOptions.sources[0].type = 'application/x-mpegURL'
							_this.start_player()
							_this.check_websocket()
						} else {
							_this.$message.error(res.data.msg);
						}
					} else {
						_this.$message.error("服务器内部错误");
					}
				});
				_this.rate.list.reverse();
			},

			start_player(src) {
				let _this = this
				if (_this.player) {
					_this.player.src({
						type: 'application/x-mpegURL',
						src: _this.videoOptions.sources[0].src
					})
					_this.player.load()
				} else {
					_this.$nextTick(() => {
						_this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions,
							function onPlayerReady() {})
					})
				}
			},

			check_websocket() {
				let _this = this
				if (_this.tabs.introduce_list.chat == '1') {
					_this.socket.websocket = new WebSocket(_this.socket.wsServer)
					_this.socket.websocket.onopen = function(evt) {
						_this.get_msg('msg')
						_this.get_msg('question')
					};
					_this.socket.websocket.onclose = function(evt) {

					};
					_this.socket.websocket.onmessage = function(evt) {
						var msg = JSON.parse(evt.data)
						if (msg.hasOwnProperty('img')) {
							msg['img'] = 'https://upload.zhiyaozhishi.com/' + msg['img']
						} else {
							msg['img'] = 'https://upload.zhiyaozhishi.com/default.jpg'
						}
						msg.time = _this.get_time()
						_this.tabs.interaction_list.push(msg)
						setTimeout(() => {
							_this.scrollToBottom('tabs');
						}, 500);
					};
					_this.socket.websocket.onerror = function(evt) {
						// console.log('socket连接错误: ' + evt.data);
					}
				}
				if (_this.tabs.introduce_list.comment == '1') {
					_this.get_comment()
				}


			},

			get_time() {
				var d = new Date();
				var year = d.getFullYear()
				var month = d.getMonth() + 1
				var day = d.getDate()
				var h = d.getHours()
				var mins = d.getMinutes()
				var s = d.getSeconds()
				if (month < 10) month = "0" + month
				if (day < 10) month = "0" + day
				if (h < 10) h = "0" + h
				if (mins < 10) mins = "0" + mins
				if (s < 10) s = "0" + s
				return (year + "-" + month + "-" + day + " " + h + ":" + mins + ":" + s)
			},

			get_msg(type) {
				let _this = this
				if (_this.tabs.introduce_list.chat == '1') {
					_this.axios.get("/v2/user_live/get_live_" + type, {
						params: {
							'num': _this.num
						},
					}).then(function(res) {
						if (res.status == "200") {
							if (res.data.code == '1') {
								if (type == 'msg') {
									// //_this.tabs.interaction_list = res.data.data
         //          _this.tabs.interaction_list=[{}]
									var json = JSON.stringify({
										'room': _this.num,
										'user': '系统通知',
										'img': 'company/companyee/default.jpg',
										'msg': '欢迎' + _this.info.rale_name + '加入本直播间'
									})
									_this.socket.websocket.send(json)
								} else {
									_this.tabs.question_list = res.data.data
								}
							} else {
								_this.$message.error(res.data.msg);
							}
						} else {
							_this.$message.error("服务器内部错误");
						}
					})
				}
			},
			get_comment() {
				let _this = this
				_this.axios.get("/v2/user_live/get_live_comment", {
					params: {
						'num': _this.num
					},
				}).then(function(res) {
					if (res.status == "200") {
						if (res.data.code == '1') {
							_this.rate.list = res.data.data.list
							_this.rate.average = res.data.data.num
						} else {
							_this.$message.error(res.data.msg);
						}
					} else {
						_this.$message.error("服务器内部错误");
					}
				})
			},
			send(value) {
				let _this = this
				if (_this.tabs.introduce_list.chat == '1') {
					let checked = '0'
					let i = _this.tabs.interaction_list.length
					let type = 'msg'
					if (_this.tabs.checked) {
						checked = '1'
						type = 'question'
					}
					var img = _this.info.img.replace('https://upload.zhiyaozhishi.com', '')
					//var json=JSON.stringify({'room':_this.num,'userNum':_this.info.serial_number,'user':_this.info.rale_name,'img':img,'msg':value,'checked':checked})
					_this.socket.websocket.send(JSON.stringify({
						'room': _this.num,
						'userNum': _this.info.serial_number,
						'user': _this.info.rale_name,
						'img': img,
						'msg': value,
						'checked': checked
					}))
					_this.save_msg(type, value)
					_this.tabs.switch = 'interaction'
					_this.input = ''
				} else {
					_this.$message.error("聊天室功能已关闭");
				}

			},

			save_msg(type, value) {
				let _this = this
				let msg_data = {
					'l_num': _this.num,
					'msg': value
				}
				if (_this.tabs.introduce_list.chat == '1') {
					_this.axios.post("/v2/user_live/save_live_" + type, {
						data: msg_data
					}).then(function(res) {

					})
				}
			},

			withdraw(num) {
				let _this = this
				for (let i = 0; i < _this.tabs.interaction_list.length; i++) {
					if (_this.tabs.interaction_list[i].num == num) {
						_this.tabs.interaction_list.splice(i, 1)
					}
				}
			},
			scrollToBottom: function(val) {
				this.$nextTick(() => {
					var container = this.$el.querySelector("#" + val);
					container.scrollTop = container.scrollHeight;
				});
			},
			//发布
			release() {
				let _this = this
				if (_this.tabs.introduce_list.chat == '1') {
					if (_this.rate.updata.content == '' || _this.rate.updata.rate_num == 0) {
						_this.$message.error('评分和内容不能为空');
						return
					}
					let lists = {
						content: _this.rate.updata.content,
						rate_num: _this.rate.updata.rate_num,
						img: _this.info.img,
						l_num: _this.$route.query.num,
					};
					_this.axios.post("/v2/user_live/save_live_comment", {
						data: lists
					}).then(function(res) {
						if (res.status == "200") {
							if (res.data.code == '1') {
								_this.rate.list.push(lists)
								_this.scrollToBottom('tabs_evaluate'),
									// _this.rate.list.reverse();
									_this.rate.updata.content = ''
								_this.rate.updata.rate_num = 0
								_this.tabs.switch = 'evaluate'
							} else {
								_this.$message.error(res.data.msg)
							}
						} else {
							_this.$message.error("服务器内部错误");
						}
					})
				} else {
					_this.$message.error("评论功能已关闭");
				}

			},

			handleClick(tab, event) {

			},

			//侧边栏
			hide() {
				let _this = this
				//获取视频宽度
				let video = _this.$refs.video.$el.clientWidth;
				let videof = _this.$refs.video.$el.parentElement.clientWidth;
				if (_this.$refs.card.$el.style.display == '') {
					//隐藏
					_this.$refs.btns.$el.style.display = 'inline'
					_this.$refs.btnh.$el.style.display = 'none'
					_this.$refs.card.$el.style.display = 'none'
					_this.$refs.video.$el.style.width = videof - 40 + 'px'
				} else {
					//显示
					_this.$refs.btnh.$el.style.display = 'inline'
					_this.$refs.btns.$el.style.display = 'none'
					_this.$refs.card.$el.style.display = ''
					_this.$refs.video.$el.style.width = '75%'
				}
				_this.change_height()
			},
			//视频与侧边栏高度
			change_height() {
				let _this = this
				let video = _this.$refs.video.$el.offsetHeight;
				let card = _this.$refs.card.$el.offsetHeight;
				let btnh = _this.$refs.btnh.$el.offsetHeight;
				let btns = _this.$refs.btns.$el.offsetHeight;
				let btntoph = video - btnh;
				let btntops = video - btns;
				_this.$refs.card.$el.style.height = video + 'px'
				_this.$refs.btnh.$el.style.top = btntoph / 2 + 'px'
				_this.$refs.btns.$el.style.top = btntops / 2 + 'px'
			},

		}
	}
</script>

<style scoped>
 >>>.el-icon-star-on:before {
    content: "\E797";
    font-size: small;
}
  .fontsize{
    font-size: small;
  }

  .relesse_div {
  	border: none;
  	background-color: transparent;
  	outline: none;
  	width: 100%;
    height: 2rem;
  }
  .chat_div_right {
  	background-color:#000000;
  	border: #000000;
  	color: #000000;
  	overflow: hidden;
  	white-space: normal;
  	word-break: break-all;
  	width: fit-content;
  	width: -webkit-fit-content;
  	width: -moz-fit-content;
  	border-radius: 10px;
  	padding: 0.5rem;
  	max-width: 70%;
  	margin-top: 0.5rem;
  	display: flex;
  	align-items: center;
  }

  .chat_div {
  	padding: 0.5rem;
  	max-width: 70%;
  	margin-top: 0.5rem;
  	background-color: white;
  	margin-left: 1rem;
  	border: #000000;
  	color: #000000;
  	overflow: hidden;
  	white-space: normal;
  	word-break: break-all;
  	width: fit-content;
  	width: -webkit-fit-content;
  	width: -moz-fit-content;
  	border-radius: 10px;
  	display: flex;
  	align-items: center;

  }

  .tabs_overflow {
  	overflow-y: no-content;
  	overflow-x: hidden;
  }
	.jiyi {
		z-index: 100;
		position: absolute;
		right: 1rem;
		bottom: 2rem;
		background-color: rgb(80, 79, 77);
		opacity: 0.7;
		color: #00F5FF;
		padding: 0 0.5rem;
		border-radius: 0.3rem;
	}

	.below-div div {
		color: white;
		height: 100%;
		width: 60px;
		float: left;
		background-color: rgb(80, 79, 77);
		border: none;
		margin-left: 10px;
		cursor: pointer;
		display: flex;
		align-items: center;
		/*定义body的元素垂直居中*/
		justify-content: center;
		/*定义body的里的元素水平居中*/

	}

	/*点赞收藏*/
	.below-div {
		display: inline-block;
		width: 100%;
		height: 40px;
		background-color: rgb(80, 79, 77);
		position: relative;
		color: white;

	}

	.main {
		min-height: calc(100vh - 330px);
		width: 70%;
		padding: 20px;
		margin: 0 15%;
		z-index: 100;
		background-color: white;
		overflow: hidden;
	}

	h1 {
		margin: 20px;
	}

	/* 视频播放 */
	.videoplay {
		max-width: 100%;
		width: 75%;
	}

	.video {
		display: block;
		height: 100%;
		position: absolute;
	}

	.whole {
		padding-bottom: 56.25%;
		height: 0;
		position: relative;
	}

	.el-form-item {
		padding: 0;
		margin: 0;
	}

	.el-form-item,
	.el-form-item__content,
	.whole,
	.video {
		width: 100%;
	}

	/* 侧边栏*/

	>>>.el-tabs__content {
		margin: 15px 20px;

	}

	.item {
		padding: 9px;
	}

	.itemactive {
		color: #008000;
		background-color: rgba(231, 245, 255, 0.6) !important;
	}

	.item:hover {
		color: #008000;
		background-color: rgba(231, 245, 255, 0.3);
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both;
	}

	.videocard {
		width: calc(25% - 1px);
		position: relative;
	}

	.box-card {
		box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);
		border: 1px solid #DCDFE6;
		border-left: 0;
		border-top: 0;
		border-radius: 0px 5px 5px 0px;
	}

	.btn-h {
		position: absolute;
		left: 0;
		top: 0;
		padding: 20px 2px;
		border-left: 0;
		border-radius: 0px 5px 5px 0px;
		background-color: rgb(0 0 0 / 12%);
	}

	.btn-s {
		display: none;
		position: absolute;
		right: 0;
		top: 0;
		padding: 20px 2px;
		border-right: 0;
		border-radius: 5px 0px 0px 5px;
		background-color: rgb(255 255 255 / 52%);
	}

	.el-tab-pane {
		height: calc(100% - 30px);
	}

	/* 笔记*/
	.con {
		margin: 15px 0;
	}

	.con>p {
		font-size: smaller;
		color: lightgray;
		margin: 2px 0;
	}

	.notes {
		height: 95%;
		overflow: auto;
	}

	.newnote {
		overflow: hidden;
	}

	.add {
		width: 100%;
		position: absolute;
		bottom: 0;
	}

	.addbtn {
		width: 100%;
		margin: 25px 0;
	}

	>>>.el-tabs__content {
		height: calc(100% - 71px);
	}

	#pane-first {
		height: 100%;
		overflow: auto;
	}

	.evaluate_end {
		width: 100%;
		position: absolute;
		bottom: 0;
	}

	.last_button {
		width: 25%;
		background-color: #E8E8E8;
		float: right;
		margin-top: 0.7rem;
		display: flex;
		justify-content: center;
		align-items: center;
    position: absolute;
    bottom:0;
    right: 0;

	}

</style>



// WEBPACK FOOTER //
// src/view/index/Live/Livebroadcasting.vue